// Overlay header behavior for the homepage and Values pages. The transparent state is used only
// at the very top of the page; any downward scroll immediately switches to
// the solid blue-gray header.
if (document.body.classList.contains('occ-overlay-header')) {
  const header = document.querySelector('#header-group');
  const occHeader = header?.querySelector('.occ-header');
  const headerSection = occHeader?.closest('.shopify-section');
  const pageWrapper = document.querySelector('.page-wrapper');

  if (header) {
    const updateHeader = () => {
      const scrollTop = Math.max(
        window.scrollY || 0,
        document.documentElement.scrollTop || 0,
        pageWrapper ? pageWrapper.scrollTop : 0
      );
      const isScrolled = scrollTop > 0;
      header.classList.toggle('is-solid', isScrolled);
      occHeader?.classList.toggle('is-scrolled', isScrolled);
      headerSection?.classList.toggle('occ-header-section--solid', isScrolled);
    };
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
    if (pageWrapper) pageWrapper.addEventListener('scroll', updateHeader, { passive: true });
  }
}
